import React, { useLayoutEffect, useRef, useState } from "react"
import { render } from "storyblok-rich-text-react-renderer"
import ServiceDropdown from "./ServiceDropdown"
import FluidImage from "../../../components/fluidImage"
import { gsap } from "gsap"

const GenerateLeadingZero = (index) => {
    if (index < 10) {
        return `0${index}`
    } else {
        return index
    }
}

const remToPx = (rem) => {
    const baseFontSize = window.getComputedStyle(document.body).getPropertyValue('font-size').replace("px", "")
    return rem * baseFontSize
}

const clampX = (x, min, max) => {
    return Math.min(Math.max(x, min), max)
}

const OptionBlock = ({service, index}) => {
    const imageRef = useRef(null)
    const [isActive, setIsActive] = useState(false)

    const onPointerMove = (e) => {

        if (imageRef.current == null) {
            return
        }

        // move the imageRef (the wrapper) using gsap to where the mouse is. 
        // adjust based on -10rem
        const x = clampX((e.clientX) - (window.innerWidth * 0.75) + remToPx(14), 0, remToPx(28.625) - remToPx(24))
        const y = (e.clientY) - (imageRef.current.parentElement.getBoundingClientRect().top) - (imageRef.current.getBoundingClientRect().height / 2)
        gsap.to(imageRef.current, {
            x: x,
            y: y,
            duration: 0.5,
            ease: "power2.out"
        })

        
    }

    return(
        <div className="grid lg:grid-cols-12 py-8 lg:py-12 gap-6 lg:gap-0">

        <div className="flex lg:col-span-5 justify-start items-start">

            <div className="flex items-center space-x-11 lg:space-x-10">
                <p className="text-lg font-medium">
                    {GenerateLeadingZero(index + 1)}
                </p>

                <h2 className="text-4xl lg:text-5xl font-serif font-thin">
                    {service.title}
                </h2>
            </div>

        </div>

        <div className="lg:col-span-7 relative" onPointerMove={onPointerMove} onMouseEnter={() => setIsActive(true)} onMouseLeave={() => setIsActive(false)}>

            {service.hover_image != undefined && (
                <div className="absolute w-[28vw] h-[20vw] -left-[calc(100%-16vw)] pointer-events-none mobile:hidden z-[-1]" ref={imageRef}>
                    <FluidImage image={service.hover_image} className={`transition-opacity duration-500 ${isActive ? `opacity-100` : `opacity-0`}`} />
                </div>

            )}


            {service.component == "rich_text_with_basic_copy" && (
                <div className="lg:text-lg lg:pr-12">
                    {render(service.copy)}
                </div>
            )}

            {service.component == "rich_text_with_dropdown" && (
                <ol className="lg:text-lg space-y-10 lg:space-y-16">
                    {
                        service.Services.map((subService, index) => {
                            return (
                                <ServiceDropdown key={`sub-service-${index}`} subService={subService} initialOpen={index == 0} />
                            )
                        })
                    }
                </ol>
            )}

        </div>

    </div>

    )
}


const ServicesBreakdown = (props) => {

    const blok = props.blok

    return (
        <section className="width">
            <div className="border-black border-t divide-y divide-black">
                {
                    blok.options.map((service, index) => {
                        return (
                            <OptionBlock service={service} index={index} key={`service-${index}`}/>
                        )
                    })
                }
            </div>
        </section>
    )
}

export default ServicesBreakdown